<template>
  <div :class="$style['layout-container']">
    <!-- 顶部 -->
    <div :class="$style['layout-header']" ref="layoutHeader">
      <div :class="$style['layout-header-brand']" @click="skiHome">
        <img
          :class="$style['layout-header-brand-logo']"
          :src="require('@/images/logo.png')"
        />
        <span :class="$style['layout-header-brand-title']">{{ sysname }}</span>
      </div>
      <div :class="$style['layout-header-right']">
        <div
          class="right-box"
          style="right: 171px; position: absolute; top: 34px"
        >
          <img :src="require('@/images/express-box.png')" />
        </div>
        <div :class="$style['sys-user']">
          <Dropdown
            transfer
            trigger="click"
            @on-click="handleClickUserDropdown"
          >
            <a href="javascript:void(0)" style="margin-right: 12px">
              <span
                style="color: #313332; font-weight: 400; font-size: 18px"
                :class="$style['sys-user-name']"
                >{{ user }}</span
              >
              <a-icon
                style="
                  color: #313332;
                  font-weight: 400;
                  margin-left: 6px;
                  font-size: 12px;
                "
                type="down"
              />
            </a>
            <Avatar :src="require('@/images/user.png')"></Avatar>
            <DropdownMenu slot="list">
              <DropdownItem style="font-size: 16px !important" name="loginout"
                >退出登录</DropdownItem
              >
            </DropdownMenu>
          </Dropdown>
        </div>
      </div>
    </div>

    <!-- 主容器 -->
    <div :class="$style['layout-main']">
      <div :class="$style['layout-main-right']">
        <!-- 内容 -->
        <div :class="$style['layout-content']" :key="viewKey">
          <div style="width: 100%; height: 100%">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import shrinkableMenu from "./main-components/shrinkable-menu/shrinkable-menu.vue";
import breadcrumbNav from "./main-components/breadcrumb-nav.vue";
import fullScreen from "./main-components/fullscreen.vue";
import lockScreen from "./main-components/lockscreen/lockscreen.vue";
import Cookies from "js-cookie";
import util from "@/libs/util.js";

export default {
  components: {
    shrinkableMenu,
    breadcrumbNav,
    fullScreen,
    lockScreen,
  },
  data() {
    return {
      pathName: "",
      pathUrl: "",
      shrink: false,
      isShow: false,
      showSearch: false, // 默认值为false
      roleId: "",
      user: "",
      isFullScreen: false,
      alarmCount: 0,
      openedSubmenuArr: this.$store.state.app.openedSubmenuArr,
      viewKey: 0,
      sysname: "广路物流管理系统",
    };
  },
  computed: {
    menuList() {
      return this.$store.state.app.menuList;
    },
    pageTagsList() {
      return this.$store.state.app.pageOpenedList; // 打开的页面的页面对象
    },
    currentPath() {
      return this.$store.state.app.currentPath; // 当前面包屑数组
    },
    avatorPath() {
      let portrait = "";
      if (window.sessionStorage.getItem("portrait")) {
        portrait = window.sessionStorage.getItem("portrait");
        this.$store.state.user.headPortrait = portrait;
        window.sessionStorage.removeItem("portrait");
      }

      return this.$store.state.user.headPortrait || "";
    },
    cachePage() {
      return this.$store.state.app.cachePage;
    },
    lang() {
      return this.$store.state.app.lang;
    },
    menuTheme() {
      return this.$store.state.app.menuTheme;
    },
    mesCount() {
      return this.$store.state.app.messageCount;
    },
  },
  methods: {
    skiHome() {
      this.$router.push({ path: "home" });
    },
    init() {
      this.roleId = Cookies.get("roleId");
      this.user = Cookies.get("user");
      // 新增获取父级路由方法
      let fatherRouteName = this.getFatherRouteName();
      let params = this.getRouterSetting();
      this.showSearch = params.search || false;

      this.$store.commit("setFatherRouteText", fatherRouteName);
      if (this.$route.name) {
        let pathArr = util.setCurrentPath(this, this.$route.name);  
        let pathList = JSON.parse(JSON.stringify(pathArr)).reverse();
        let copy_pathArr = "";
        if (pathList.length > 0) {
          copy_pathArr = pathList[0].title;
        } 
        this.setGloablValue();
        this.$store.commit("setCurrentPageText", copy_pathArr);
        this.$store.commit("updateMenulist");
        if (pathArr.length >= 2) {
          this.$store.commit("addOpenSubmenu", pathArr[1].name);
        }

        this.checkTag(this.$route.name);
      }
    },
    toggleClick() {
      this.shrink = !this.shrink;
    },
    handleClickUserDropdown(name) {
      if (name === "loginout") {
        this.$store.commit("logout");
        Cookies.remove("user");
        Cookies.remove("access");
        Cookies.remove("token");
        Cookies.remove("roleId");
        Cookies.remove("_id");
        self.location.href = "login.html";
      }
    },

    checkTag(name) {
      if (this.pageTagsList[0] != undefined) {
        let openpageHasTag = this.pageTagsList.some((item) => {
          if (item.name === name) {
            return true;
          }
        });
        if (!openpageHasTag) {
          //  解决关闭当前标签后再点击回退按钮会退到当前页时没有标签的问题
          util.openNewPage(
            this,
            name,
            this.$route.params || {},
            this.$route.query || {}
          );
        }
      }
    },

    handleSubmenuChange(val) {},

    beforePush(name) {
      return true;
    },
    // 返回父级
    getFatherRouteName() {
      let minPathLen = 0;
      let fatherName = "";
      this.$route.matched.forEach((item) => {
        let path_length = item.path.length;

        if ((path_length < minPathLen || minPathLen == 0) && item.meta) {
          minPathLen = path_length.length;
          fatherName = item.meta.title;
        }
      });
      return fatherName || "";
    },

    // 获取路由配置信息并返回
    getRouterSetting() {
      return JSON.parse(JSON.stringify(this.$route.meta));
    },

    // 设置全局值
    setGloablValue() {
      this.$nextTick(() => {
        // 全局暴露公共vueComponent
        window.VUECOMPONENT = {};
        window.VUECOMPONENT.headerBar = this.$refs.headerBar;
      });
    },
  },
  watch: {
    $route(to) {
      // 新增父级路由名称获取
      let fatherRouteName = this.getFatherRouteName();
      let params = this.getRouterSetting();
      this.showSearch = params.search || false;
      this.$store.commit("setFatherRouteText", fatherRouteName);
      this.$store.commit(
        "setCurrentPageText",
        to.meta instanceof Object ? to.meta.title : ""
      );

      this.setGloablValue();
      this.$store.commit("setCurrentPageName", to.name);
      let pathArr = util.setCurrentPath(this, to.name);
      if (pathArr.length > 2) {
        this.$store.commit("addOpenSubmenu", pathArr[1].name);
      }

      if (to && to.name) {
        this.checkTag(to.name);
      }

      localStorage.currentPageName = to.name;
    },
    lang() {
      util.setCurrentPath(this, this.$route.name); // 在切换语言时用于刷新面包屑
    },
    openedSubmenuArr() {
      setTimeout(() => {
        //this.scrollBarResize();
      }, 300);
    },
  },
  mounted() {
    window.addEventListener("resize", () => {
      // resize时重新渲染home
      if (this.$route.path.indexOf("home") > -1) {
        this.viewKey = Date.now();
      }
    });
    this.init();
  },
  created() {
    // 显示打开的页面的列表
    this.$store.commit("setOpenedList");
  },
  dispatch() {},
};
</script>
<style module>
.layout-container {
  display: flex;
  background: linear-gradient(180deg, #ebf5ee 0%, #d8f0e5 100%, #dcf4e9 100%);
  box-shadow: inset 0px -1px 0px 0px #ced3e5 !import;
  height: 100%;
  width: 100%;
  flex-direction: column;
  overflow: hidden;
}

.layout-header {
  position: relative;
  z-index: 1;
  height: 88px;
  display: flex;
  align-items: center;
  font-weight: normal;
  color: #ffffff;
  justify-content: space-between;
  flex-shrink: 0;
}

.layout-header-brand {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.layout-header-brand-logo {
  height: 48px;
  width: 48px;
  margin-left: 16px;
}

.layout-header-brand-title {
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 24px;
  color: #313332;
  line-height: 33px;
  text-align: left;
  font-style: normal;
  margin-left: 8px;
}

.layout-header-right {
  display: flex;
  align-items: center;
}

.sys-tools {
  display: flex;
  align-items: center;
}

/* .sys-tools * {
  margin-right: 0.2rem;
} */

.sys-user {
  margin-left: 10px;
  margin-right: 20px;
}

.sys-user a {
  color: #666;
}

.layout-main {
  position: relative;
  z-index: 0;
  display: flex;
  flex: 1;
  min-height: 0;
  min-width: 0;
}

.layout-main-left {
  display: flex;
  overflow: auto;
  width: 14rem;
  flex-shrink: 0;
}

.layout-main-right {
  display: flex;
  flex: 1;
  height: 100%;
  width: 100%;
  flex-direction: column;
  overflow: hidden;
}

.layout-main-right-header {
  display: flex;
  width: 100%;
  height: 50px;
}

.layout-content {
  position: relative;
  display: flex;
  flex: 1;
  width: 100%;
  height: 100%;
  overflow: auto;
}
</style>

<style lang="less" scoped>
/deep/.ivu-avatar {
  width: 40px;
  height: 40px;
}
/deep/.ant-layout {
  background: unset !important;
}
</style>
